import nativeCreate from './_nativeCreate';

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

export default hashClear;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_hashClear.js
// module id = 314
// module chunks = 0